import {
	Backdrop,
	createStyles,
	Fade,
	makeStyles,
	Modal,
} from "@material-ui/core";
import React, { memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import buttonClose from "../../../assets/kinologyIcons/svg/close.svg";
import { AppActions } from "../../../store/ducks/app";
import { Container } from "./styles";
import { ReactComponent as CheckIcon } from "../../../assets/kinologyIcons/svg/check.svg";
import { Colors } from "../../../styles/colors";
import { useDataSubscription } from "../../../hooks/useDataSubscription";
import { Icon } from "../../../styles/global";
import ErrorIcon from "../../../assets/kinologyIcons/svg/error.svg";
import upgradeIllustration from "../../../assets/kinologyIcons/svg/imgUpgrade.svg";

const useStyles = makeStyles(() =>
	createStyles({
		modal: {
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			padding: "1rem",
		},
	})
);

const listFeatures = [
	"Avaliadores ilimitados",
	"Relatórios ilimitados",
	"Garantia do hardware até 2 anos",
	"Suporte prioritário",
];

const ModalUpgradeSubscription: React.FC = () => {
	const dispatch = useDispatch();
	const classes = useStyles();

	const is_open_modal_upgrade_subscription = useSelector(
		(state: any) => state.app.is_open_modal_upgrade_subscription
	);

	const { registredUnifiedReport, selectedService, isPlanExpired } =
		useDataSubscription("uni_complete_report");

	const reportLimit = Number(selectedService?.value);
	const isLimitReached =
		selectedService?.value !== "unlimited" &&
		selectedService?.value !== undefined &&
		registredUnifiedReport >= reportLimit;

	const ModalClose = () => {
		if (!isLimitReached && !isPlanExpired) {
			dispatch(AppActions.set_open_modal_upgrade_subscription(false));
		} else {
			return;
		}
	};

	const handleContactExperts = () => {
		window.open(
			"https://wa.me/556133479291?text=Ol%C3%A1%2C%20gostaria%20de%20mudar%20o%20meu%20plano%20",
			"_blank",
			"noopener,noreferrer"
		);
	};

	return (
		<Modal
			aria-labelledby="modal-upgrade-subscription-title"
			aria-describedby="modal-upgrade-subscription-description"
			className={classes.modal}
			open={is_open_modal_upgrade_subscription}
			onClose={ModalClose}
			closeAfterTransition
			BackdropComponent={Backdrop}
			BackdropProps={{
				timeout: 500,
			}}
		>
			<Fade in={is_open_modal_upgrade_subscription}>
				<Container>
					{!isLimitReached && !isPlanExpired ? (
						<img
							className="close"
							src={buttonClose}
							onClick={ModalClose}
							alt="Fechar"
						/>
					) : null}

					{isLimitReached ? (
						<div
							style={{
								display: "flex",
								flexDirection: "column",
								alignItems: "center",
								gap: "10px",
								color: Colors.neutral_grey_k_60,
								padding: "1rem",
								borderRadius: "10px",
								marginBottom: "1rem",
								marginTop: "1rem",
								border: `1px solid ${Colors.tertirary_red_2_dark}22`,
								backgroundColor: `${Colors.tertirary_red_2_dark}22`,
							}}
						>
							<div
								style={{
									display: "flex",
									alignItems: "center",
									gap: "5px",
								}}
							>
								<Icon
									src={ErrorIcon}
									style={{
										width: 28,
										height: 28,
									}}
								/>

								<p
									style={{
										color: Colors.tertirary_red_2_dark,
										fontWeight: 500,
									}}
								>
									Acesso ao desktop pausado
								</p>
							</div>

							<p
								style={{
									margin: 0,
									flex: 1,
									lineHeight: "22px",
								}}
							>
								Você atingiu o limite mensal de relatórios do seu plano. Para
								continuar gerando novas análises e acessar os dados do desktop
								sem interrupções, é necessário fazer o upgrade.
							</p>
						</div>
					) : (
						<img
							className="illustration"
							src={upgradeIllustration}
							alt=""
							aria-hidden="true"
						/>
					)}

					<h2 id="modal-upgrade-subscription-title" className="title">
						Faça upgrade e tenha acesso a essas funcionalidades
					</h2>

					<p id="modal-upgrade-subscription-description" className="subtitle">
						Desbloqueie todo o potencial da nossa plataforma.
					</p>

					<ul className="features">
						{listFeatures.map((feature) => (
							<li key={feature} className="featureItem">
								<CheckIcon
									width={18}
									height={14}
									style={{ color: Colors.primary_blue_k_main }}
								/>
								<span>{feature}</span>
							</li>
						))}
					</ul>

					<button className="ctaButton" onClick={handleContactExperts}>
						Fale com nossos especialistas
					</button>
				</Container>
			</Fade>
		</Modal>
	);
};

export default memo(ModalUpgradeSubscription);
